import { FC } from 'react';

import styled from '@emotion/styled';

import { STATUS_LABEL, UsageStatus } from './format';

const PALETTE: Record<UsageStatus, { bg: string; fg: string; border: string }> =
  {
    within_plan: { bg: '#f0f3f9', fg: '#4a5878', border: '#d5dbe7' },
    near_limit: { bg: '#fff6d6', fg: '#7a5a00', border: '#f0d27a' },
    over_plan: { bg: '#fdecea', fg: '#9b2118', border: '#f2b8b3' },
  };

const Pill = styled.span<{ status: UsageStatus }>`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  background: ${({ status }) => PALETTE[status].bg};
  color: ${({ status }) => PALETTE[status].fg};
  border: 1px solid ${({ status }) => PALETTE[status].border};
`;

const StatusTag: FC<{ status: UsageStatus }> = ({ status }) => (
  <Pill status={status}>{STATUS_LABEL[status]}</Pill>
);

export default StatusTag;
